import { Action } from 'redux';

import { ChannelTypes } from '../../home/types/ChannelTypes';
import { isShowMoreRecommendationsAction } from '../actions/ShowMoreRecommendationsAction';
import {
  initialRecommendationsShowMoreState,
  RecommendationsShowMoreState} from '../state/RecommendationsState';

export function recommendationsShowMoreReducer(
  previousState: RecommendationsShowMoreState = { ...initialRecommendationsShowMoreState },
  action: Action
) {
  if (isShowMoreRecommendationsAction(action)) {
    return showMoreRecommendations(
      previousState,
      action.numCardsToShow,
      action.channelType
    );
  }
  return previousState;
}

function showMoreRecommendations(
  previousState: RecommendationsShowMoreState,
  numCardsToShow: number,
  channelType: ChannelTypes
) {
  if (channelType === ChannelTypes.recsSimilarUsers) {
    return {
      ...previousState,
      similarUsers: numCardsToShow,
    };
  } else if (channelType === ChannelTypes.recsDataMonitoring) {
    return {
      ...previousState,
      dataMonitoring: numCardsToShow,
    };
  } else if (channelType === ChannelTypes.recsPopular) {
    return {
      ...previousState,
      popular: numCardsToShow,
    };
  }
  return previousState;
}
